import { CartItem as CartItemType } from "custom-types/Cart";
import { useSelector } from "redux/hooks";
import { getCartChanges } from "redux/selectors/cart";

import CartItem from "../CartItem";

type Props = {
  items: CartItemType[];
  isEmbedded?: boolean;
};

const CartItemContainer = ({ items, isEmbedded }: Props) => {
  const cartChanges = useSelector(getCartChanges);
  return (
    <div data-testid="cart-container" className="flex flex-col gap-4">
      {items.map((item) => {
        const change = cartChanges.find(
          (itemChange) =>
            itemChange.metadata &&
            itemChange.metadata.variant_id === item.variantId,
        );
        return (
          <CartItem
            editable={true}
            item={item}
            key={item.variantId}
            warning={change && change.message}
            isEmbedded={isEmbedded}
          />
        );
      })}
    </div>
  );
};

export default CartItemContainer;
